<template>
  <div class="bbe-line-height" v-click-outside="close">
    <div class="bbe-line-height__item"
         v-for="lineHeight in lineHeightList"
         @click="setLineHeight(lineHeight)"
         :key="lineHeight">
      {{lineHeight}}
    </div>
  </div>
</template>

<script>
import lineHeight from '@/constants/toolbarEditorOptions/lineHeight'

export default {
  name: 'LineHeightSelect',
  data () {
    return {
      lineHeightList: lineHeight
    }
  },
  methods: {
    setLineHeight (size) {
      this.$emit('set', size)
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bbe-line-height {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: $color-white;
    min-width: 55px;
    padding: 6px 0;
    width: 100%;

    &__item {
      text-align: center;
      width: 100%;
      padding: 6px 2px;
      font-size: 13px;
      transition: 0.3s;

      &:hover {
        background-color: $color-gallery;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/TextEditor/LineHeightSelect/LineHeightSelect.vue